import { Chip } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette';
import { useTranslate } from 'react-admin';

export const MarketingPriorityField = ({ record }) => {
    const translate = useTranslate();
    if (!record) return null;

    const getPriorityLabel = priority => {
        switch (priority) {
            case 0:
                return { label: translate('common.priority.high'), backgroundColor: Palette.red.red100 };
            case 1:
                return { label: translate('common.priority.normal'), backgroundColor: Palette.yellow.yellow100 };
            case 2:
                return { label: translate('common.priority.low'), backgroundColor: Palette.blue.blue100 };
            default:
                return { label: translate('common.priority.unknown'), backgroundColor: Palette.gray.gray100 };
        }
    };

    const { label, backgroundColor } = getPriorityLabel(record.priority);

    return (
        <Chip
            label={label}
            size='small'
            style={{ backgroundColor: backgroundColor }}
            sx={{
                borderRadius: '6px',
            }}
        />
    );
};
